import React from "react";
import { object } from "prop-types";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import ComponentContainer from "../../layouts/component-container";

import "./fiveOpinionStories.m.css";

const FiveOpinionStories = ({ collection }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { items = [] } = collection;
  const stories = items.filter(({ type }) => type === "story");

  if (!stories.length) {
    return null;
  }

  const [firstStory, ...otherStories] = stories.slice(0, 5);

  return (
    <ComponentContainer styleName="base" collection={collection}>
      <div styleName="container">
        <Organism1 story={firstStory} />
        {otherStories.length > 1 && <Organism2 stories={otherStories} />}
      </div>
    </ComponentContainer>
  );
};

FiveOpinionStories.propTypes = {
  collection: object.isRequired,
};

FiveOpinionStories.storyLimit = 5;

export default FiveOpinionStories;
